import { GlobalAxios } from "../axios/axios-config";
import { IExternalCalendarPreference } from "../models/external-calendar-preference";

const CALENDAR_REFERENCE_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/CalendarPreference";

export const externalCalendarPreference = (params?: {
  TasyScheduleTypeCodeList?: number[];
  tasyScheduleTypeCode?: number;
  enableCode?: boolean;
}) => {
  return GlobalAxios.get<IExternalCalendarPreference[]>(
    CALENDAR_REFERENCE_ROUTE,
    {
      params,
      paramsSerializer: { indexes: null },
    },
  );
};
